module.exports = __webpack_public_path__ + "img/amar_no.8e9a3677.png";